import React from "react";

function DebuffIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className="svg-inline--fa fa-dove fa-w-16 fa-s"
    >
      <path
        fill="#fff"
        d="M296.863 16.45c17.48 71.11 24.22 245.104-34.8 319.093l11.26 19.447.134.276c1.7 3.442 2.233 7.003 1.975 10.472l.148-.08-15.764 95.8-19.425-52.462v81.33h7.067c55.25-17.22 98.094-24.153 174.5-3.68 55.486 14.867 95.82-25.906 67.127-107.337-39.195-111.238-35.708-258.27 1.853-362.86H296.863zm-128.21 146.946c-13.198.006-30.01 4.504-46.2 13.805-16.19 9.302-28.502 21.534-35.094 32.882-6.592 11.348-7.234 20.674-3.626 26.893 3.61 6.22 12.106 10.362 25.303 10.357 13.197-.005 30.006-4.504 46.197-13.805 16.19-9.3 28.503-21.532 35.094-32.88 6.59-11.35 7.236-20.674 3.627-26.893-3.61-6.22-12.106-10.363-25.303-10.358zm14.626 73.37c-5.64 4.68-11.91 9.044-18.737 12.966a135.051 135.051 0 01-16.813 8.182l73.598 126.654.125.248c.69 1.37.927 1.63 4.81 1.397 3.88-.233 9.92-2.238 15.385-5.453 5.467-3.215 10.42-7.624 12.99-11.31 2.536-3.644 2.417-5.126 2.067-5.862L183.28 236.766zm12.197 140.51c-5.563 3.395-11.23 6.89-16.995 10.525-33.785 21.3-68.207 38.483-93.943 45.15-64.52-14.67-91.224 57.353-28.68 57.353l.005.023h165.838v-84.834l-14.1 35.766-4.728-51.25-7.398-12.73z"
      ></path>
    </svg>
  );
}

export default DebuffIcon;
